import { React } from 'Imports';
import { isEncompass } from '$Utilities/integrationPlatform';

const styles = require('./DetailsField.scss') as {
    labelEncompass: string;
    valueEncompass: string;
    labelGeotab: string;
    valueGeotab: string;
};

const DetailsField = ({ label, children }: { label: string; children: React.ReactNode }) => {
    return (
        <>
            <span className={isEncompass ? styles.labelEncompass : styles.labelGeotab}>{label}</span>
            <span className={isEncompass ? styles.valueEncompass : styles.valueGeotab}>{children}</span>
        </>
    );
};

export default DetailsField;
